import { useState, useEffect } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { NPSDReportsGrid } from '@/components/npsd/NPSDReportsGrid';
import { NPSDCallCardsGrid } from '@/components/npsd/NPSDCallCardsGrid';

import { Codes } from '@/constants/codes';

interface NPSDPersonHistoryProps {
  personId: number | null;
  reports: any[];
  active?: boolean;
  onViewReport?: (reportId: any) => void;
}

export function NPSDPersonHistory({
  personId = null,
  reports = [],
  active = false,
  onViewReport,
}: NPSDPersonHistoryProps) {
  const { theme } = useTheme();
  const [personCodes, setPersonCodes] = useState<any[]>([]);
  const [offenseCodes, setOffenseCodes] = useState<any[]>([]);

  // Load codes for roles/offenses display
  useEffect(() => {
    if (typeof Codes !== 'undefined') {
      setPersonCodes(Codes.getPersonCodes() || []);
      setOffenseCodes(Codes.getOffenseCodes() || []);
    }
  }, []);

  return (
    <div className={`npsd-person-history ${theme}`}>
      {/* Reports Section */}
      <NPSDReportsGrid
        reports={reports}
        title="Reports Involving Person"
        entityType="person"
        showRoles={true}
        showOffenses={true}
        personCodes={personCodes}
        offenseCodes={offenseCodes}
        onViewReport={onViewReport}
      />

      {/* Call Cards Section */}
      <NPSDCallCardsGrid
        entityId={personId}
        entityType="person"
        entityIdField="personId"
        title="Call Cards Involving Person"
        active={active}
      />
    </div>
  );
}

(window as any).NPSDPersonHistoryReact = NPSDPersonHistory;
